<template>
  <div class="settings-bot-rive__container">
    <canvas ref="canvas" width="400" height="400" class="settings-bot-rive"></canvas>
  </div>
</template>

<script>
import {Rive, Layout, Fit, Alignment} from '@rive-app/canvas';

let riveAnimation;

export default {
  name: 'SettingsBotRive',

  props: {
    src: String,
    fit: String,
    alignment: String
  },
  
  mounted() {
    riveAnimation = new Rive({
      canvas: this.$refs.canvas,
      src: "rive/gatsby_bot.riv",
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.TopCenter,
      }),
      autoplay: true,
      onLoad: () => {
        riveAnimation.resizeDrawingSurfaceToCanvas()
      },
    })
  },

  unmounted() {
    if (riveAnimation !== undefined && riveAnimation !== null) {
      riveAnimation.cleanupInstances(); // Остановить анимацию
      
      riveAnimation = null; // Очистить ссылку на анимацию
    }
  }
}
</script>
<style lang="scss" scoped>
.settings-bot-rive {
  width: 47em;
  display: block;
  position: absolute;
  right: -4em;
  top: -11em;
  z-index: 0;
  pointer-events: none;

  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    display: none;
  }
}
</style>